<template>
  <div class="Login">
    <div class="header" :class="scrollDistance > 3 ? 'headerBg' : ''">
      <div class="headLeft">
        <div class="headLogo">
          <img class="img1" src="../assets/logo.png" alt="">
          <img class="img2" src="../assets/logo2.png" alt="">
        </div>
        <div class="headUl">
          <div class="headli" @click="to_loginShow(1)">
            发布任务
          </div>
          <div class="headli" @click="to_loginShow(1)">
            接任务
          </div>
          <div class="headli" @click="to_loginShow(1)">
            任务大厅
          </div>
          <div class="headli" @click="to_help()">
            帮助中心
          </div>
        </div>
      </div>
      <div class="headRig">
        <div class="headBtn headBAct" @click="to_loginShow(2)">
          立即注册
        </div>
        <div class="headBtn headBDl" @click="to_loginShow(1)">
          登录
        </div>
      </div>
    </div>
    <div class="inBanBox">
      <div class="inBanImg">
        <video ref="videoRef" autoplay loop muted="false">
          <source :src="data.ivideo.video" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="inBanTbox">
        <template>
        <div class="inBanTit">
          {{data.ivideo.title}}<br>  {{data.ivideo.ftitle}}
        </div>
        </template>
        <!-- <div class="inBanText">
            专业大平台，成就好商单
        </div> -->
        <div class="inBanBtnBox">
          <div class="inBanBtn" @click="to_loginShow(1)">
            <svg t="1724232403647" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="4316" width="200" height="200">
              <path
                d="M512 0C371.2 0 256 115.2 256 256s115.2 256 256 256 256-115.2 256-256-115.2-256-256-256z m0 85.333333c93.866667 0 170.666667 76.8 170.666667 170.666667s-76.8 170.666667-170.666667 170.666667-170.666667-76.8-170.666667-170.666667 76.8-170.666667 170.666667-170.666667zM810.666667 597.333333H213.333333c-119.466667 0-213.333333 93.866667-213.333333 213.333334s93.866667 213.333333 213.333333 213.333333h597.333334c119.466667 0 213.333333-93.866667 213.333333-213.333333s-93.866667-213.333333-213.333333-213.333334zM213.333333 682.666667h597.333334c72.533333 0 128 55.466667 128 128s-55.466667 128-128 128H213.333333c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128z"
                fill="#4C4C4C" p-id="4317"></path>
              <path
                d="M810.666667 810.666667h-170.666667c-25.6 0-42.666667-17.066667-42.666667-42.666667s17.066667-42.666667 42.666667-42.666667h170.666667c25.6 0 42.666667 17.066667 42.666666 42.666667s-17.066667 42.666667-42.666666 42.666667z"
                fill="#E02020" p-id="4318"></path>
            </svg> 我是客户
          </div>
          <div class="inBanBtn inBanSJS" @click="to_loginShow(1)">
            <svg t="1724232461561" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5982" width="200" height="200">
              <path
                d="M949.972495 593.443917l-95.529727-95.529727c-4.776793-4.77577-11.073196-7.219425-17.369599-7.219425-6.243191 0-12.538571 2.443655-17.369599 7.219425L524.428565 793.189194c-3.581572 3.581572-5.753027 8.032954-6.730285 12.646018l-0.107447 0-17.911952 125.112486-0.217964 0.054235 0.10847 0.705058-1.846044 12.81077c-0.325411 0.921999-0.542352 1.953492-0.542352 2.930749 0 3.853771 2.822278 6.947226 6.621814 7.382131l0 0.325411 0.760317-0.162706c0.10847 0 0.10847 0.054235 0.10847 0.054235 1.085728 0 2.170432-0.216941 3.039219-0.597611l134.176932-24.15412 0-0.107447c4.77577-0.86981 9.227152-3.148713 12.809747-6.731308l295.275004-295.275004C959.526081 618.575294 959.526081 602.997504 949.972495 593.443917zM622.185007 877.320313l-60.249199 10.856255 9.011234-62.909795 266.12715-266.12715 51.67287 51.67287L622.185007 877.320313z"
                fill="#030000" p-id="5983"></path>
              <path
                d="M684.008051 595.180468c-38.2123-25.40153-80.766488-44.834114-126.686331-55.906288 89.234347-36.69269 152.414295-124.353193 152.414295-226.667439 0-135.208425-110.077048-245.175979-245.231237-245.175979-135.26266 0-245.230214 109.967554-245.230214 245.175979 0 102.314247 63.071478 189.973726 152.304801 226.667439C197.130218 581.286016 66.861292 738.260164 66.861292 925.520081c0 15.306614 12.484336 27.79095 27.79095 27.79095 15.415085 0 27.79095-12.484336 27.79095-27.79095 0-188.616822 153.500023-342.06261 342.06261-342.06261 65.677838 0 126.903272 18.99768 179.119517 51.238988L684.008051 595.180468zM274.856463 312.607764c0-104.540961 84.999906-189.595103 189.649338-189.595103 104.540961 0 189.649338 85.054141 189.649338 189.595103 0 104.539938-85.108377 189.649338-189.649338 189.649338C359.856369 502.257102 274.856463 417.147702 274.856463 312.607764z"
                fill="#030000" p-id="5984"></path>
              <path
                d="M928.261007 900.986315 724.174865 900.986315c-15.360849 0-27.79095 12.375865-27.79095 27.789926 0 15.306614 12.4301 27.79095 27.79095 27.79095l204.086142 0c15.361873 0 27.79095-12.484336 27.79095-27.79095C956.051957 913.36218 943.62288 900.986315 928.261007 900.986315z"
                fill="#030000" p-id="5985"></path>
            </svg> 我是设计师
          </div>
        </div>
      </div>
      <div class="inBanList">
        <div class="inBanItem" v-for="(subItem, subIndex) in data.inum">
          <img class="InBIcon" :src="subItem.pic" alt="">
          <!-- <b>98164</b> -->
          <b>{{subItem.num}}<i>{{subItem.dw}}</i></b>
          <p>{{subItem.title}}</p>
        </div>

      </div>
    </div>
    <div class="inCBox padd">
      <div class="inner">
        <div class="inCTop" ref="myinCTop">
          <div class="inTit">
            {{data.icona.title}}
          </div>
          <div class="inText">
            {{data.icona.ftitle}}
          </div>
        </div>
        <div class="inCList">
          <div class="inCItem" v-for="(subItem, subIndex) in data.iconac" v-if="subIndex==0">
            <img class="inCIcon" :src="subItem.pic" alt="">
            <div class="inCNum">
              01
            </div>
            <div class="inCTit">
              {{ subItem.title }}
            </div>
            <div class="inCText">
              {{ subItem.con }}
            </div>
          </div>
          <div class="inCSan">
            <img src="../assets/san.png" alt="">
          </div>
          <div class="inCItem" v-for="(subItem, subIndex) in data.iconac" v-if="subIndex==1">
            <img class="inCIcon" :src="subItem.pic" alt="">
            <div class="inCNum">
              02
            </div>
            <div class="inCTit">
              {{ subItem.title }}
            </div>
            <div class="inCText">
              {{ subItem.con }}
            </div>
          </div>
          <div class="inCSan">
            <img src="../assets/san.png" alt="">
          </div>
          <div class="inCItem" v-for="(subItem, subIndex) in data.iconac" v-if="subIndex==2">
            <img class="inCIcon" :src="subItem.pic" alt="">
            <div class="inCNum">
              03
            </div>
            <div class="inCTit">
              {{ subItem.title }}
            </div>
            <div class="inCText">
              {{ subItem.con }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inHBox padd">
      <div class="inner">
        <div class="inHTop">
          <div class="inHTopA">
            <div class="inTit">
              {{data.iconb.title}}
            </div>
            <div class="inText">
              {{data.iconb.ftitle}}
            </div>
          </div>
          <div class="inHRig">
            <el-carousel class="inHRig_carousel" direction="vertical" :autoplay="true">
              <el-carousel-item v-for="item in data.iconb.con" :key="item">
                <div class="inHRText">
                  <template>
                  <p v-html="item"></p>
                  </template>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="inHList">
          <div class="inHItem"  v-for="item in data.iconbc">
            <div class="inHImg">
              <img :src="item.pic" alt="">
            </div>
            <div class="inHTbox">
              <div class="inHTit">
                {{item.title}}
              </div>
              <div class="inHText">
                {{item.ftitle}}
              </div>
              <div class="inHBon">
                <div class="inHLeft">
                  <div class="inHIcon">
                    <svg t="1724219722885" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="3118" width="200" height="200">
                      <path d="M207.715 164.379h608.57v48h-608.57zM207.715 808.522h608.57v48h-608.57z" p-id="3119">
                      </path>
                      <path
                        d="M366.988 836.334h-48V652.763a60.863 60.863 0 0 1 21.489-46.456l311.967-265.064a12.939 12.939 0 0 0 4.568-9.876v-143.7h48v143.7a60.856 60.856 0 0 1-21.489 46.456L371.557 642.887a12.936 12.936 0 0 0-4.569 9.876v183.571z"
                        p-id="3120"></path>
                      <path
                        d="M705.012 836.334h-48V652.763c0-3.81-1.665-7.41-4.567-9.876L340.477 377.821a60.863 60.863 0 0 1-21.489-46.456v-143.7h48v143.7c0 3.81 1.665 7.409 4.569 9.876l311.967 265.064a60.86 60.86 0 0 1 21.488 46.456v183.573z"
                        p-id="3121"></path>
                      <path d="M438.311 691.637h147.378v48H438.311z" p-id="3122"></path>
                    </svg>
                  </div>
                  <p> 待接单：<span> {{item.num}}单</span></p>
                </div>
                <div class="inHBtn">
                  接单赚钱
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="footer">
      <div class="inner">
        {{data.web_config.web_cop}} <a href="https://beian.miit.gov.cn/" target="_blank"  rel="nofollow">{{data.web_config.web_icp }}</a>
      </div>
    </div>
    <!-- <div class="BulletBg" v-if="loginShow" @click="to_loginShow()"></div>
    <div class="BulletBox" v-if="loginShow">
     
    </div> -->
    <el-dialog title="" class="BulletBox" :visible.sync="pwdShow">
      <div class="Log_Tbox">
        <img class="Log_logo" src="../assets/logo2.png" alt="">
        <div class="Log_Tit">找回密码</div>
        <div class="Log_From">
          <el-form ref="LoginFrom" :model="pwdFrom">
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402560735" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="4302" width="200" height="200">
                  <path
                      d="M517.883 953.6c27.927 0 50.683-22.756 50.683-51.717 0-27.927-22.756-50.683-50.683-50.683s-51.717 22.756-51.717 50.683c1.034 28.961 23.79 51.717 51.717 51.717zM759.665 0h-495.33C206.371 0 160 45.511 160 102.4v819.2c0 56.889 46.371 102.4 104.335 102.4h495.33C817.629 1024 864 978.489 864 921.6V102.4C864 45.511 817.629 0 759.665 0z m1.16 972.8H274.682c-27.927 0-50.683-22.756-50.683-51.717V800h588.541v121.083c-1.034 27.927-23.79 51.717-51.717 51.717zM800 729.083H224v-614.4C224 86.756 246.232 64 273.516 64h474.947c27.284 0 49.516 22.756 49.516 50.683v614.4H800z"
                      fill="" p-id="4303"></path>
                </svg>
              </div>
              <el-input placeholder="手机号码" v-model="pwdFrom.name1"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402800258" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="5283" width="200" height="200">
                  <path
                      d="M943.1 172c-2.4-0.2-245.1-25.3-413.8-147.8-5.1-3.7-11-5.6-17.3-5.6-6.2 0-12.2 1.9-17.3 5.6C326.9 146 83.3 171.8 80.9 172c-15.2 1.4-26.6 14.1-26.6 29.3 0 6.7 0.6 165.8 54.8 344.4 32.1 105.8 76.4 196.4 131.9 269.2 70.3 92.3 158.5 156 262 189.2 2.9 0.9 5.9 1.4 9 1.4s6.1-0.5 8.9-1.4c103.6-33.2 191.7-96.8 262-189.2 55.4-72.7 99.8-163.2 131.9-269.2 54.1-178.6 54.8-337.7 54.8-344.4C969.7 186.1 958.3 173.5 943.1 172zM910.1 227.2l-0.1 1.6c-2.9 58.1-13.4 174.4-51.4 299.9-66.7 220.1-183.1 360.1-346 416.1L512 945l-0.6-0.2C349 888.9 232.7 749.4 165.8 530.1c-39.8-130.5-49.4-254.2-51.8-301.4l-0.1-1.6 1.5-0.2c70.6-10.3 250.5-44.8 395.5-142.4l0.9-0.7 1 0.7C658 182.1 837.9 216.6 908.5 227L910.1 227.2z"
                      p-id="5284"></path>
                  <path
                      d="M641.8 351 467 580.3l-89-76.1c-5.3-4.5-12.1-7-19.1-7-8.6 0-16.8 3.7-22.4 10.3-10.5 12.3-9.1 31 3.3 41.5l112.7 96.4c5.2 4.4 12.4 7 19.6 7 0.9 0 1.8 0 2.7-0.1 8-0.8 15.4-5 20.3-11.4l193.7-254c4.8-6.3 6.8-14 5.7-21.8-1-7.8-5.1-14.7-11.3-19.5C670.1 335.6 651.6 338.1 641.8 351z"
                      p-id="5285"></path>
                </svg>
              </div>
              <el-input placeholder="验证码" v-model="pwdFrom.name2"> </el-input>
              <div class="Log_Yzm" @click="getyzma()">{{ isCountingDown ? '重新获取(' + countdown + ')' : '获取验证码' }}</div>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402824421" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="6282" width="200" height="200">
                  <path
                      d="M800.256 338.432H223.232c-78.848 0-143.36 64-143.36 142.336v400.896c0 78.336 64.512 142.336 143.36 142.336h577.024c78.848 0 143.36-64 143.36-142.336v-400.896c0-78.336-64.512-142.336-143.36-142.336z m78.336 543.232c0 43.008-35.328 77.824-78.336 77.824H223.232c-43.52 0-78.336-34.816-78.336-77.824v-400.896c0-43.008 35.328-77.824 78.336-77.824h577.024c43.52 0 78.336 34.816 78.336 77.824v400.896zM260.096 296.448c0-128 104.96-231.936 233.472-231.936h36.352c128.512 0 233.472 103.936 233.472 231.936v11.264h64.512v-11.264c0-163.328-133.632-296.448-297.984-296.448h-36.352c-164.352 0-297.984 133.12-297.984 296.448v11.264h64.512v-11.264z m219.136 480.256h64.512v-214.528h-64.512v214.528z"
                      fill="" p-id="6283"></path>
                </svg>
              </div>
              <el-input placeholder="新密码" type="password"  v-model="pwdFrom.name3"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402867532" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="7560" width="200" height="200">
                  <path
                      d="M241.1 358.5h-54.2v-33.4c0-43.9 8.6-86.5 25.6-126.6 16.4-38.7 39.8-73.5 69.7-103.3 29.8-29.8 64.6-53.3 103.3-69.7C425.5 8.6 468.1 0 512 0c43.9 0 86.5 8.6 126.6 25.6 38.7 16.4 73.5 39.8 103.3 69.7 29.8 29.8 53.3 64.6 69.7 103.3 17 40.1 25.6 82.7 25.6 126.6H783c0-149.4-121.5-270.9-270.9-270.9-149.4 0-270.9 121.5-270.9 270.9v33.3z"
                      p-id="7561"></path>
                  <path
                      d="M810 1024H214c-74.7 0-135.5-60.8-135.5-135.5V455c0-74.7 60.8-135.5 135.5-135.5h596c74.7 0 135.5 60.8 135.5 135.5v433.5c0 74.7-60.8 135.5-135.5 135.5zM214 373.8c-44.8 0-81.3 36.5-81.3 81.3v433.5c0 44.8 36.5 81.3 81.3 81.3h596c44.8 0 81.3-36.5 81.3-81.3V455c0-44.8-36.5-81.3-81.3-81.3H214z"
                      p-id="7562"></path>
                  <path d="M463.1 829.4L303.2 669.5l38.3-38.3 121.6 121.6 219.4-219.5 38.3 38.4z" p-id="7563"></path>
                </svg>
              </div>
              <el-input placeholder="确认密码" type="password"  v-model="pwdFrom.name4"> </el-input>
            </el-form-item>
            <button class="Log_Btn" @click.prevent="on_logonpwd()">找回密码</button>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" class="BulletBox" :visible.sync="loginShow">
      <div class="Log_Tbox">
        <img class="Log_logo" src="../assets/logo2.png" alt="">
        <div class="Log_Tit"> {{ loginId == 1 ? '登录云剪辑账户' : '' }} {{ loginId == 2 ? '我是设计师，立即注册' : '' }}{{ loginId == 3
          ? '我有需求，立即注册' : '' }}
        </div>
        <div class="Log_Text"> {{ loginId == 1 ? '发现更多好商单' : '' }}{{ loginId == 2 ? '发现更多好商单' : '' }}{{ loginId == 3 ?
          '发布视频剪辑任务' : '' }}</div>
        <div class="Log_From">
          <el-form ref="LoginFrom" :model="LoginFrom" v-if="loginId != 1">
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402560735" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4302" width="200" height="200">
                  <path
                    d="M517.883 953.6c27.927 0 50.683-22.756 50.683-51.717 0-27.927-22.756-50.683-50.683-50.683s-51.717 22.756-51.717 50.683c1.034 28.961 23.79 51.717 51.717 51.717zM759.665 0h-495.33C206.371 0 160 45.511 160 102.4v819.2c0 56.889 46.371 102.4 104.335 102.4h495.33C817.629 1024 864 978.489 864 921.6V102.4C864 45.511 817.629 0 759.665 0z m1.16 972.8H274.682c-27.927 0-50.683-22.756-50.683-51.717V800h588.541v121.083c-1.034 27.927-23.79 51.717-51.717 51.717zM800 729.083H224v-614.4C224 86.756 246.232 64 273.516 64h474.947c27.284 0 49.516 22.756 49.516 50.683v614.4H800z"
                    fill="" p-id="4303"></path>
                </svg>
              </div>
              <el-input placeholder="手机号码" v-model="LoginFrom.name1"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402800258" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5283" width="200" height="200">
                  <path
                    d="M943.1 172c-2.4-0.2-245.1-25.3-413.8-147.8-5.1-3.7-11-5.6-17.3-5.6-6.2 0-12.2 1.9-17.3 5.6C326.9 146 83.3 171.8 80.9 172c-15.2 1.4-26.6 14.1-26.6 29.3 0 6.7 0.6 165.8 54.8 344.4 32.1 105.8 76.4 196.4 131.9 269.2 70.3 92.3 158.5 156 262 189.2 2.9 0.9 5.9 1.4 9 1.4s6.1-0.5 8.9-1.4c103.6-33.2 191.7-96.8 262-189.2 55.4-72.7 99.8-163.2 131.9-269.2 54.1-178.6 54.8-337.7 54.8-344.4C969.7 186.1 958.3 173.5 943.1 172zM910.1 227.2l-0.1 1.6c-2.9 58.1-13.4 174.4-51.4 299.9-66.7 220.1-183.1 360.1-346 416.1L512 945l-0.6-0.2C349 888.9 232.7 749.4 165.8 530.1c-39.8-130.5-49.4-254.2-51.8-301.4l-0.1-1.6 1.5-0.2c70.6-10.3 250.5-44.8 395.5-142.4l0.9-0.7 1 0.7C658 182.1 837.9 216.6 908.5 227L910.1 227.2z"
                    p-id="5284"></path>
                  <path
                    d="M641.8 351 467 580.3l-89-76.1c-5.3-4.5-12.1-7-19.1-7-8.6 0-16.8 3.7-22.4 10.3-10.5 12.3-9.1 31 3.3 41.5l112.7 96.4c5.2 4.4 12.4 7 19.6 7 0.9 0 1.8 0 2.7-0.1 8-0.8 15.4-5 20.3-11.4l193.7-254c4.8-6.3 6.8-14 5.7-21.8-1-7.8-5.1-14.7-11.3-19.5C670.1 335.6 651.6 338.1 641.8 351z"
                    p-id="5285"></path>
                </svg>
              </div>
              <el-input placeholder="验证码" v-model="LoginFrom.name2"> </el-input>
              <div class="Log_Yzm" @click="getyzm()">{{ isCountingDown ? '重新获取(' + countdown + ')' : '获取验证码' }}</div>

            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402824421" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6282" width="200" height="200">
                  <path
                    d="M800.256 338.432H223.232c-78.848 0-143.36 64-143.36 142.336v400.896c0 78.336 64.512 142.336 143.36 142.336h577.024c78.848 0 143.36-64 143.36-142.336v-400.896c0-78.336-64.512-142.336-143.36-142.336z m78.336 543.232c0 43.008-35.328 77.824-78.336 77.824H223.232c-43.52 0-78.336-34.816-78.336-77.824v-400.896c0-43.008 35.328-77.824 78.336-77.824h577.024c43.52 0 78.336 34.816 78.336 77.824v400.896zM260.096 296.448c0-128 104.96-231.936 233.472-231.936h36.352c128.512 0 233.472 103.936 233.472 231.936v11.264h64.512v-11.264c0-163.328-133.632-296.448-297.984-296.448h-36.352c-164.352 0-297.984 133.12-297.984 296.448v11.264h64.512v-11.264z m219.136 480.256h64.512v-214.528h-64.512v214.528z"
                    fill="" p-id="6283"></path>
                </svg>
              </div>
              <el-input placeholder="设置密码" type="password"  v-model="LoginFrom.name3"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402867532" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="7560" width="200" height="200">
                  <path
                    d="M241.1 358.5h-54.2v-33.4c0-43.9 8.6-86.5 25.6-126.6 16.4-38.7 39.8-73.5 69.7-103.3 29.8-29.8 64.6-53.3 103.3-69.7C425.5 8.6 468.1 0 512 0c43.9 0 86.5 8.6 126.6 25.6 38.7 16.4 73.5 39.8 103.3 69.7 29.8 29.8 53.3 64.6 69.7 103.3 17 40.1 25.6 82.7 25.6 126.6H783c0-149.4-121.5-270.9-270.9-270.9-149.4 0-270.9 121.5-270.9 270.9v33.3z"
                    p-id="7561"></path>
                  <path
                    d="M810 1024H214c-74.7 0-135.5-60.8-135.5-135.5V455c0-74.7 60.8-135.5 135.5-135.5h596c74.7 0 135.5 60.8 135.5 135.5v433.5c0 74.7-60.8 135.5-135.5 135.5zM214 373.8c-44.8 0-81.3 36.5-81.3 81.3v433.5c0 44.8 36.5 81.3 81.3 81.3h596c44.8 0 81.3-36.5 81.3-81.3V455c0-44.8-36.5-81.3-81.3-81.3H214z"
                    p-id="7562"></path>
                  <path d="M463.1 829.4L303.2 669.5l38.3-38.3 121.6 121.6 219.4-219.5 38.3 38.4z" p-id="7563"></path>
                </svg>
              </div>
              <el-input placeholder="确认密码" type="password"  v-model="LoginFrom.name4"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1727574335126" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4283" width="200" height="200"><path d="M775.68 848.64H394.24c-51.2 0-98.56-23.04-133.12-64-11.52-14.08-10.24-33.28 3.84-44.8 14.08-11.52 33.28-10.24 44.8 3.84 23.04 26.88 52.48 40.96 84.48 40.96h382.72c66.56 0 120.32-64 120.32-142.08V381.44c0-78.08-53.76-142.08-120.32-142.08H394.24c-66.56 0-120.32 64-120.32 142.08v48.64c0 17.92-14.08 32-32 32s-32-14.08-32-32v-48.64c0-113.92 83.2-206.08 184.32-206.08h382.72C876.8 175.36 960 268.8 960 381.44v261.12c0 112.64-83.2 206.08-184.32 206.08z" p-id="4284" fill="#888888"></path><path d="M357.12 582.4H167.68c-17.92 0-32-14.08-32-32s14.08-32 32-32h189.44c17.92 0 32 14.08 32 32s-14.08 32-32 32zM285.44 684.8H96C78.08 684.8 64 670.72 64 652.8s14.08-32 32-32h189.44c17.92 0 32 14.08 32 32s-14.08 32-32 32zM599.04 519.68c-6.4 0-14.08-2.56-19.2-6.4L281.6 280.32c-14.08-10.24-16.64-30.72-5.12-44.8 10.24-14.08 30.72-16.64 44.8-5.12l279.04 217.6 262.4-204.8c14.08-11.52 34.56-8.96 44.8 5.12 10.24 14.08 8.96 34.56-5.12 44.8l-281.6 220.16c-7.68 3.84-14.08 6.4-21.76 6.4z" p-id="4285" fill="#888888"></path></svg>
              </div>
              <el-input placeholder="邀请码"  v-model="LoginFrom.name5"> </el-input>
            </el-form-item>
            <button class="Log_Btn" @click.prevent="on_logon()">创建账户</button>
            <button class="Log_Btn Log_BDl" @click.prevent="to_loginShow(1)">已有账户，登录现有账户</button>
            <div class="LoginTy">
              <div class="LoginTyuan" :class="{ 'act': isyd }"  @click="toggleIsyd">
                <img src="../assets/dui.png" alt="">
              </div>
              <p>我已阅读并同意<span  @click="serviceShow = true">服务条款</span>和<span @click="privacyShow =true" >隐私协议</span>。</p>
            </div>
          </el-form>
          <el-form ref="LoginFrom" :model="LoginFrom" v-if="loginId == 1">
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402560735" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4302" width="200" height="200">
                  <path
                    d="M517.883 953.6c27.927 0 50.683-22.756 50.683-51.717 0-27.927-22.756-50.683-50.683-50.683s-51.717 22.756-51.717 50.683c1.034 28.961 23.79 51.717 51.717 51.717zM759.665 0h-495.33C206.371 0 160 45.511 160 102.4v819.2c0 56.889 46.371 102.4 104.335 102.4h495.33C817.629 1024 864 978.489 864 921.6V102.4C864 45.511 817.629 0 759.665 0z m1.16 972.8H274.682c-27.927 0-50.683-22.756-50.683-51.717V800h588.541v121.083c-1.034 27.927-23.79 51.717-51.717 51.717zM800 729.083H224v-614.4C224 86.756 246.232 64 273.516 64h474.947c27.284 0 49.516 22.756 49.516 50.683v614.4H800z"
                    fill="" p-id="4303"></path>
                </svg>
              </div>
              <el-input placeholder="手机号码" v-model="LoginFrom.name1"> </el-input>
            </el-form-item>
            <el-form-item class="Log_Item">
              <div class="Log_Icon">
                <svg t="1724402824421" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6282" width="200" height="200">
                  <path
                    d="M800.256 338.432H223.232c-78.848 0-143.36 64-143.36 142.336v400.896c0 78.336 64.512 142.336 143.36 142.336h577.024c78.848 0 143.36-64 143.36-142.336v-400.896c0-78.336-64.512-142.336-143.36-142.336z m78.336 543.232c0 43.008-35.328 77.824-78.336 77.824H223.232c-43.52 0-78.336-34.816-78.336-77.824v-400.896c0-43.008 35.328-77.824 78.336-77.824h577.024c43.52 0 78.336 34.816 78.336 77.824v400.896zM260.096 296.448c0-128 104.96-231.936 233.472-231.936h36.352c128.512 0 233.472 103.936 233.472 231.936v11.264h64.512v-11.264c0-163.328-133.632-296.448-297.984-296.448h-36.352c-164.352 0-297.984 133.12-297.984 296.448v11.264h64.512v-11.264z m219.136 480.256h64.512v-214.528h-64.512v214.528z"
                    fill="" p-id="6283"></path>
                </svg>
              </div>
              <el-input placeholder="密码"  type="password" v-model="LoginFrom.name3"> </el-input>
            </el-form-item>
            <button class="Log_Btn" @click.prevent="to_logon()">登录</button>
            <button class="Log_Btn Log_BDl" @click.prevent="to_loginShow(3)">去注册</button>
            <button class="Log_Btn Log_BDl" @click.prevent="to_pwdShow()">忘记密码，找回密码</button>

            <div class="LoginTy">
              <div class="LoginTyuan " :class="{ 'act': isyd }"  @click="toggleIsyd">
                <img src="../assets/dui.png" alt="">
              </div>
              <p>我已阅读并同意<span @click="serviceShow = true">服务条款</span>和<span  @click="privacyShow = true">隐私协议</span>。</p>
            </div>
          </el-form>
        </div>
      </div>
      <div class="Log_Bon" v-if="loginId == 1||loginId == 2" @click.prevent="to_loginShow(3)">
        我有需求，立即注册
       </div>

      <div class="Log_Bon" v-if="loginId == 3" @click.prevent="to_loginShow(2)">
        我是设计师，立即注册
      </div>
    </el-dialog>
    <el-dialog title="服务条款" class="helpTan" :visible.sync="serviceShow">
      <div class="helpTkBox" v-html="fwtk">
       </div>
    </el-dialog>
    <el-dialog title="隐私协议" class="helpTan" :visible.sync="privacyShow">
      <div class="helpTkBox" v-html="yszc">

      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'login',
  data() {
    return {
      loginShow: false,
      LoginFrom: {},
      pwdShow: false,
      pwdFrom: {},
      fwtk: '',
      yszc: '',
      data:{},
      serviceShow: false,
      privacyShow:false,
      loginId:0,
      messageData:'',
      isyd: false,
      countdown: 60, // 倒计时初始值
      isCountingDown: false, // 是否正在倒计时
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.fetchTableData();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleIsyd() {
      this.isyd = !this.isyd;
    },
    to_pwdShow(){
      this.pwdShow=true;
      this.loginShow=false;

    },
    to_loginShow(e) {
      console.log(e)
      if(e==1){
        this.fwtk=this.data.fwtk[0].con
        this.yszc=this.data.fwtk[1].con
      }
      if(e==2){
        this.fwtk=this.data.fwtk[2].con
        this.yszc=this.data.fwtk[4].con
      }
      if(e==3){
        this.fwtk=this.data.fwtk[3].con
        this.fwtk=this.data.fwtk[3].con
        this.yszc=this.data.fwtk[5].con
      }
      this.loginShow = true
      this.isyd = false
      let id = e;
      this.loginId = id;
      this.LoginFrom=[]

    },
    handleScroll() {
      this.scrollDistance = window.scrollY;
    },
    to_help(){
      this.$router.push('/help')
    },
    to_logon() {
      if(!this.LoginFrom.name1){
        this.$message({
          type: 'warning',
          message: "请填写手机号码"
        });
        return;
      }
      if(!this.LoginFrom.name3){
        this.$message({
          type: 'warning',
          message: "请填写密码"
        });
        return;
      }
      if(!this.isyd){
        this.$message({
          type: 'error',
          message: "请先阅读并同意服务条款和隐私协议"
        });
        return;
      }
      //
      axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=login', {
        'title': this.LoginFrom.name1,
        'pwd': this.LoginFrom.name3,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
            if (response.data.status == 1) {
              this.$router.push('/Home')
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    fetchTableData() {
      console.log(123)
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=index')
          .then(response => {
            // 处理成功情况
            this.data = response.data;
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });

    },
    on_logonpwd(){
      if(!this.pwdFrom.name1){
        this.$message({
          type: 'warning',
          message: "请填写手机号码"
        });
        return;
      }
      if(!this.pwdFrom.name2){
        this.$message({
          type: 'warning',
          message: "请填写验证码"
        });
        return;
      }
      if(!this.pwdFrom.name3){
        this.$message({
          type: 'warning',
          message: "请输入密码"
        });
        return;
      }
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(this.pwdFrom.name3)) {
        this.$message({
          type: 'error',
          message: "密码至少8位，并且包括英文和数字"
        });
        return;
      }
      if(!this.pwdFrom.name4){
        this.$message({
          type: 'warning',
          message: "请输入确认密码"
        });
        return;
      }
      if(this.pwdFrom.name4!=this.pwdFrom.name3){
        this.$message({
          type: 'warning',
          message: "密码和确认密码需相同"
        });
        return;
      }
      axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=loginon', {
        'title': this.pwdFrom.name1,
        'yzm': this.pwdFrom.name2,
        'pwd': this.pwdFrom.name3,
        'pwda': this.pwdFrom.name4,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.data.status == 1) {
              this.pwdShow=false;
              this.loginShow=true;
              this.loginId=1
              this.LoginFrom={}
            } else {
              this.$message({
                type: 'info',
                message: response.data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    on_logon() {
      if(!this.LoginFrom.name1){
        this.$message({
          type: 'warning',
          message: "请填写手机号码"
        });
        return;
      }
      if(!this.LoginFrom.name2){
        this.$message({
          type: 'warning',
          message: "请填写验证码"
        });
        return;
      }
      if(!this.LoginFrom.name3){
        this.$message({
          type: 'warning',
          message: "请输入密码"
        });
        return;
      }
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(this.LoginFrom.name3)) {
        this.$message({
          type: 'error',
          message: "密码至少8位，并且包括英文和数字"
        });
        return;
      }
      if(!this.LoginFrom.name4){
        this.$message({
          type: 'warning',
          message: "请输入确认密码"
        });
        return;
      }
      if(this.LoginFrom.name4!=this.LoginFrom.name3){
        this.$message({
          type: 'warning',
          message: "密码和确认密码需相同"
        });
        return;
      }
      if(!this.isyd){
        this.$message({
          type: 'error',
          message: "请先阅读并同意服务条款和隐私协议"
        });
        return;
      }
      console.log(this.LoginFrom)
      axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=register', {
        'type': this.loginId==2?2:1,
        'title': this.LoginFrom.name1,
        'yzm': this.LoginFrom.name2,
        'pwd': this.LoginFrom.name3,
        'pwda': this.LoginFrom.name4,
        'yqm': this.LoginFrom.name5,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.data.status == 1) {
              this.loginId=1
              this.LoginFrom={}
            } else {
              this.$message({
                type: 'info',
                message: response.data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    getyzm() {
      if (!this.isCountingDown) {
        axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=getyzm',{
          'title':this.LoginFrom.name1,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(response => {
              if(response.data.status==1){
                this.isCountingDown = true;
                this.startCountdown();
              }else{
                this.$message({
                  type: 'info',
                  message: response.data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
    getyzma() {
      if (!this.isCountingDown) {
        axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=getyzma',{
          'title':this.pwdFrom.name1,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(response => {
              if(response.data.status==1){
                this.isCountingDown = true;
                this.startCountdown();
              }else{
                this.$message({
                  type: 'info',
                  message: response.data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
    startCountdown() {
      const interval = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(interval);
          this.countdown = 60; // 重置倒计时
          this.isCountingDown = false; // 允许重新点击
        } else {
          this.countdown--;
        }
      }, 1000);
    }
  }
}
</script>

<style>

.header {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 50px;
  background: rgba(255, 255, 255, .2);
  /* border-bottom: 1px solid rgba(255, 255, 255, .2); */
}

.headerBg {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, .1);
}

.headerBg .headli {
  color: #333;

}

.headerBg .headBDl {
  border: 1px solid rgba(0, 0, 0, .3);
  color: #333;
}

.headerBg .headBDl:hover {
  background: #333;
  color: #fff;
}

.headLeft {
  display: flex;
  align-items: center;
}

.headLogo {
  width: 50px;
}

.headLogo img {
  width: 100%;
}

.headLogo .img1 {
  display: block;
}

.headLogo .img2 {
  display: none;
}

.headerBg .headLogo .img2 {
  display: block;
}

.headerBg .headLogo .img1 {
  display: none;
}

.headUl {
  margin-left: 30px;
  display: flex;
  align-items: center;
}

.headli {
  margin-left: 40px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}

.headRig {
  display: flex;
  align-items: center;
}

.headBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border: 1px solid rgba(255, 255, 255, .8);
  border-radius: 8px;
  width: 100px;
  height: 40px;
  background: #fff;
  margin-left: 20px;
  cursor: pointer;
  transition: all 0.48s;
  color: #FF5000;
}

/* .headBDl:hover {
  background: #fff;
  color: #FF5000;
} */

.headBtn.headBAct {
  background: #FF5000;
  color: #fff;
  border: 1px solid #FF5000;
}

.inBanBox {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.inBanImg {
  width: 100%;
  height: 100%;
  position: relative;
}

.inBanImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.inBanImg video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.inBanImg video source {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.inBanTbox {
  width: 60%;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.inBanTit {
  font-size: 56px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  letter-spacing: 4px;
  animation: inBPc .8s;
}

.inBanText {
  font-size: 20px;
  color: #fff;
  opacity: .6;
  text-align: center;
  letter-spacing: 1px;
  margin-top: 20px;
}

.inBanBtnBox {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: inBPc .8s .2s;
  animation-fill-mode: backwards;
}

.inBanBtn {
  margin: 0 10px;
  width: 200px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.48s;
  color: #FF5000;
}

.inBanBtn svg {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.inBanBtn svg path {
  fill: #FF5000;
}

.inBanBtn:nth-child(1) {
  background: #FF5000;
  border: transparent;
  color: #fff;
}

.inBanBtn:nth-child(1) svg path {
  fill: #fff;
}

/* .inBanSJS:hover {
  background: #FF5000;
  color: #fff;
}

.inBanSJS:hover svg path{
  fill: #fff;
} */
.inBanList {
  width: 82%;
  position: absolute;
  left: 50%;
  bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translateX(-50%);

}

@keyframes inBPc {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.inBanItem {
  animation-fill-mode: backwards;
  animation-fill-mode: both;
  animation: inBPc .8s .4s;
  /* width: calc(33.3% - 30px); */
  padding: 30px;
  border-radius: 16px;
  /* background: rgba(255, 255, 255, .2); */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.InBIcon {
  width: 30px;
}

.inBanItem b {
  font-size: 52px;
  font-weight: 600;
  color: #fff;
  line-height: 1;
  letter-spacing: 2px;
  margin: 15px 0 20px;
  display: block;
  /* font-family: 'Montserrat'; */
}

.inBanItem i {
  font-size: 14px;
  color: rgba(255, 255, 255, .8);
}

.inBanItem p {
  font-size: 14px;
  color: rgba(255, 255, 255, .8);
}

.inCBox {
  position: relative;

}

.padd {
  padding: 98px 0;
}

.inner {
  width: 86%;
  margin: 0 auto;
}

.inCTop {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.inTit {
  font-size: 42px;
  font-weight: 600;
  color: #333;
}

.inText {
  font-size: 20px;
  margin-top: 10px;
  color: #666;
}

.inCBox {
  background: #fff;
  position: relative;
}

.inCList {
  margin-top: 70px;
  padding: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f4f7ff;
  border-radius: 16px;
}

.inCItem {
  width: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.inCItem:hover .inCTit {
  margin: 10px 0;
  color: #FF5000;
}

.inCIcon {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

.inCNum {
  font-size: 28px;
  font-weight: 600;
  position: relative;
  /* font-family: 'Montserrat'; */
}

.inCNum::after {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 20px;
  top: 20px;
  content: '';
  background: #f4f7ff;
  border-top: 1px solid rgba(0, 0, 0, .8);
  transform: rotate(-40deg);
}

.inCTit {
  font-size: 24px;
  font-weight: 600;
  margin: 15px 0;
  transition: all 0.48s;
}

.inCText {
  font-size: 14px;
  text-align: center;
  color: #666;
  line-height: 1.8;
}

.inCSan {
  width: 30px;
  height: 30px;
}

.inCSan img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}








/* 灵活用工 */
.inHBox {
  position: relative;
  background: #f4f7ff;
}

.inHTop {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.inHTopA {
  width: 50%;
  position: relative;
}

.inHRig {
  width: 35%;
  height: 50px;
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, .3);
  position: relative;
  overflow: hidden;
}

.inHRig_carousel {
  width: 100%;
  height: 100%;
}

.inHRText {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 30px;
}

.inHRText p {
  font-size: 14px;
  width: calc(100% - 80px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.inHRig_carousel .inHRText span {
  font-size: 14px;
  color: #FF5000;
}

.el-carousel__container {
  height: 100% !important;
}

.inHList {
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
}

.inHItem {
  width: calc(33.3% - 50px);
  background: #fff;
  border-radius: 16px;
  padding: 20px;
}

.inHItem:hover .inHImg img {
  transform: scale(1.1);
}

.inHImg {
  width: 100%;
  padding-top: 65%;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
}

.inHImg img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
  transition: all 0.48s;
}

.inHTbox {
  position: relative;
  padding: 30px 0 0;
}

.inHTit {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  transition: all 0.48s;
}

.inHItem:hover .inHTit {
  color: #FF5000;
}

.inHText {
  font-size: 14px;
  color: #999;
}

.inHBon {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.inHLeft {
  display: flex;
  align-items: center;
}

.inHIcon {
  width: 25px;
  height: 25px;
}

.inHIcon svg {
  width: 100%;
  height: 100%;
  position: relative;
}

.inHIcon svg path {
  fill: #444;
}

.inHIcon svg path:last-child {
  fill: #FF5000;
}

.inHLeft p {
  font-size: 16px;
  color: #333;
}

.inHLeft span {
  color: #FF5000;
  /* font-family: 'Montserrat'; */
}

.inHBtn {
  width: 100px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FF5000;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

















/* 底部 */
.footer {
  position: relative;
  padding: 30px 0;
}

.footer a {
  font-size: 14px;
  color: #999;
  text-decoration: none;
}

@media(max-width:1024px) {
  .footer {
    padding: 20px 0;
  }
}














.BulletBg {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, .5);
  transition: all 0.48s;
}

.BulletBg.BulletBgAct {
  z-index: 9999;
  opacity: 1;
}

.BulletBox.BulletBoxAct {
  z-index: 99;
  opacity: 1;
  transform: translate(-50%, -50%);
}

.BulletBox {
  /* width: 550px; */
  /* background: #fff;
  border-radius: 20px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -40%);
  z-index: 10000;
  overflow: hidden;
  transition: all 0.48s; */
}
.BulletBox .el-dialog{
  width: 550px !important;
  margin-top: 3% !important;
}
.BulletBox .el-dialog__header{
  display: none;
}
.BulletBox .el-dialog__body{
  padding: 0
}
.Log_Tbox {
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.Log_logo {
  width: 45px;
  height: 45px;
}

.Log_Tit {
  font-size: 36px;
  line-height: 1;
  margin: 15px 0;
  font-weight: 600;
}

.Log_Text {
  font-size: 18px;
  color: #666;
}

.Log_From {
  width: 420px;
  margin-top: 20px;
}

.Log_Item {
  border: 1px solid rgba(0, 0, 0, .3);
  border-radius: 20px;
  overflow: hidden;
  padding: 0 20px;
  margin-bottom: 10px !important;
}

.Log_Item .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.Log_Item .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px !important;
  padding: 0 10px;
}

.LoginTy {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px
}

.LoginTy p {
  font-size: 14px;
  color: #999;
}

.LoginTy span {
  font-size: 14px;
  color: #FF5000;
  cursor: pointer;
}

.LoginTyuan {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  cursor: pointer;
}

.LoginTyuan img {
  width: 60%;
  height: 60%;
  opacity: 0;
}

.LoginTyuan.act {
  background: #FF5000;
  border: #FF5000;
}

.LoginTyuan.act img {
  opacity: 1;
}

.Log_Bon {
  background: #eee;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  height: 70px;
  line-height: 70px;
  cursor: pointer;
}

.Log_Btn {
  width: 420px;
  height: 50px;
  border-radius: 50px;
  background: #FF5000;
  color: #fff;
  font-size: 16px;
  display: block;
  margin: 20px auto 0;
  border: none;
}

.Log_BDl {
  border: 1px solid rgba(0, 0, 0, .3);
  color: #333;
  background: transparent;
}

.Log_BTx {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.Log_BTx p {
  font-size: 14px;
  color: #666;
}

.Log_BTx a {
  font-size: 14px;
  color: #FF5000;
}

.Log_BTxz {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .5);
  margin-right: 10px;
}

.Log_Icon {
  position: relative;
  width: 20px;
  height: 30px;
}

.Log_Icon svg {
  width: 100%;
  height: 100%;
}

.Log_Icon svg path {
  fill: #888;
}

.Log_Yzm {
  font-size: 14px;
  position: absolute;
  right: 0;
  color: #999;
  cursor: pointer;
}

.helpTkBox p{
  font-size: 14px;
  line-height: 30px
}










@media (max-width: 1468px) {
  .Log_Tit {
    font-size: 32px;
  }

  .Log_Text {
    font-size: 16px;
  }

  .inBanItem b {
    font-size: 46px;
  }

  .Log_Item .el-input__inner {
    height: 45px;
    line-height: 45px;
  }

  .inHItem {
    width: calc(33.3% - 30px);
  }

  .inTit {
    font-size: 38px;
  }

  .inCTit {
    font-size: 22px;
  }

  .padd {
    padding: 78px 0;
  }
}

@media (max-width: 1280px) {
  .inHList {
    margin-top: 50px;
  }

  .Log_Tit {
    font-size: 28px;
  }

  .Log_Input input {
    font-size: 15px;
  }

  .Log_Btn {
    margin-top: 10px;
  }

  .Log_Item {
    margin-bottom: 10px;
  }

  .Log_logo {
    width: 40px;
    height: 40px;
  }

  .Log_Bon {
    background: #eee;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    height: 65px;
    line-height: 65px;
  }

  .inBanTit {
    font-size: 48px;
    line-height: 1.4;
  }

  .inBanBtnBox {
    margin-top: 30px;
  }

  .inBanBtn {
    width: 180px;
    height: 55px;
  }

  .inBanItem b {
    font-size: 42px;
  }

  .inText {
    font-size: 18px;
  }

  .inCSan {
    width: 24px;
    height: 24px;
  }

  .inCItem {
    width: 26%;
  }

  .inCList {
    margin-top: 50px;
  }

  .inCList {
    padding: 50px;
  }

  .inTit {
    font-size: 36px;
  }

  .inCTit {
    font-size: 20px;
  }

  .inHItem {
    width: calc(33.3% - 15px);
  }

  .inHLeft p {
    font-size: 14px;
  }

  .inHBtn {
    width: 90px;
  }

  .inHTit {
    font-size: 22px;
  }
}

@media(max-width:1024px) {
  .header {
    padding: 15px 30px;
  }

  .headLogo {
    width: 45px;
  }

  .headli {
    margin-left: 30px;
  }

  .inBanTit {
    font-size: 42px;
    line-height: 1.4;
  }

  .inBanBtn {
    width: 160px;
    height: 50px;
    font-size: 15px;
  }

  .inBanItem {
    padding: 0;
  }

  .InBIcon {
    width: 25px;
  }

  .inBanItem b {
    font-size: 36px;
    margin: 10px 0;
  }

  .inBanBox {
    height: 700px;
  }

  .inCList {
    padding: 30px;
  }

  .inCItem {
    width: 28%;
  }

  .inCTit {
    font-size: 20px;
  }

  .inHTop {
    flex-wrap: wrap;
  }

  .inHTopA {
    width: 100%;
    margin-bottom: 30px;
  }

  .inHItem {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .inHItem:last-child {
    margin-bottom: 0;
  }

  .inHImg {
    width: 50%;
    padding-top: 30%;
  }

  .inHTbox {
    width: 45%;
  }

  .inHList {
    flex-wrap: wrap;
  }

  .padd {
    padding: 68px 0;
  }

  .inTit {
    font-size: 32px;
  }

  .inText {
    font-size: 16px;
  }

  .inHRig {
    width: 100%;
  }
}

@media(max-width:900px) {
  .headUl {
    display: none;
  }

  .footer a {
    font-size: 12px;
  }

  .inBanTit {
    font-size: 36px;
    line-height: 1.2;
  }

  .inBanBtn {
    width: 150px;
    height: 50px;
    font-size: 14px;
  }

  .inBanItem b {
    font-size: 28px;
    margin: 10px 0;
  }

  .InBIcon {
    width: 22px;
  }

  .inBanItem p {
    font-size: 12px;
  }

  .inCList {
    flex-wrap: wrap;
  }

  /* .inCSan{
      display: none;
    } */
  .inCItem {
    width: 100%;
  }

  .inCItem:hover .inCTit {
    margin: 15px 0;
    color: #FF5000;
  }

  .inCSan {
    width: 24px;
    height: 24px;
    margin: 20px auto;
  }

  .inCSan img {
    transform: rotate(90deg);
  }

  .inCNum::after {
    width: 0;
  }

  .padd {
    padding: 58px 0;
  }
}

@media(max-width:680px) {
  .padd {
    padding: 48px 0;
  }

  .inCItem:hover .inCTit {
    margin: 10px 0;
  }

  .inCItem .inCTit {
    margin: 10px 0;
  }

  .inHItem {
    flex-wrap: wrap;
  }

  .inHImg {
    width: 100%;
    padding-top: 65%;
  }

  .inHTbox {
    width: 100%;
  }

  .inTit {
    font-size: 28px;
  }

  .inText {
    font-size: 14px;
  }

  .inHRig {
    height: 40px;
  }

  .inBanTbox {
    width: 90%;
  }

  .inBanTit {
    font-size: 32px;
  }

  .BulletBox {
    width: 90%;
  }

  .Log_From {
    width: 100%;
  }

  .Log_Btn {
    width: 100%;
  }

  .headBtn {
    width: 80px;
    margin-left: 10px;
  }

  .headLogo {
    width: 40px;
  }

  .inBanList {
    width: 90%;
  }

  .inBanBox {
    height: 600px;
  }

  .inHBon {
    margin-top: 10px;
  }

  .inCIcon {
    width: 130px;
    height: 130px;
  }

  .inBanItem i {
    font-size: 12px;
  }

  .inBanItem b {
    font-size: 26px;
  }

  .inCTop .inText {
    text-align: center;
  }

  .inHTit {
    font-size: 20px;
  }

  .Log_Tit {
    font-size: 24px;
  }

  .Log_Text {
    font-size: 14px;
  }
}

@media(max-width:500px) {
  .Log_Tbox {
    padding: 20px 30px;
  }

  .header {
    padding: 10px 20px;
  }

  .headBtn {
    width: 70px;
    margin-left: 10px;
    font-size: 12px;
  }

  .inBanTit {
    font-size: 28px;
  }

  .inBanList {
    width: 98%;
  }

  .inBanItem b {
    font-size: 24px;
  }

  .inTit {
    font-size: 24px;
  }

  .inCNum {
    font-size: 24px;
  }
}
</style>